import { createContext, useState, useEffect } from 'react';

const AppContext = createContext();

export function AppProvider({ children }) {
  const [filterModalShow, setFilterModalShow] = useState(false);
  const toggleFilterModal = () => {
    setFilterModalShow(!filterModalShow);
  }

  const hideFilterModal = () => {
    setFilterModalShow(false);
  }

  const showFilterModal = () => {
    setFilterModalShow(true);
  }

  const [productModalShow, setProductModalShow] = useState(false);

  const [cartModalShow, setCartModalShow] = useState(false);
  const hideCartModal = () => {
    setCartModalShow(false)
  }
  const openCartModal = () => {
    setCartModalShow(true);
  }
  const toggleCartModal = () => {
    setCartModalShow(!cartModalShow);
  }

  const [cartPage, setCartPage] = useState("cart");

  // set cart page to "cart", "shipping" or "order"
  const changeCartPage = (page) => {
    setCartPage(page);
  }

  const [deliveryMethod, setDeliveryMethod] = useState(null);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [deliverySettings, setDeliverySettings] = useState(null)
  const [deliveryLocation, setDeliveryLocation] = useState(null)
  const [pickupLocations, setPickupLocations] = useState(null)

  const selectDeliveryMethod = (event) => {
    switch (event) {
      case "pickup":
        setDeliveryMethod('pickup');
        setDeliveryLocation(null);
        setDeliveryFee(0);
        break;
      case "delivery":
        setDeliveryMethod('delivery');
        break;
      case "none":
        setDeliveryMethod(null);
        setDeliveryLocation(null);
        setDeliveryFee(0);
        break;
      default:
        setDeliveryMethod(null);
        setDeliveryLocation(null);
        setDeliveryFee(0);
    }
  }

  const selectDeliveryLocation = (location) => {
    setDeliveryLocationFee(location)
    if (location === 'none') {
      setDeliveryLocation(null);
      setShippingFormValues({ ...shippingFormValues, deliveryLocation: null });
    } else {
      setDeliveryLocation(location);
      setShippingFormValues({ ...shippingFormValues, deliveryLocation: location });
    }
  }

  const selectPickupLocation = (location) => {
    if (location === 'none') {
      setShippingFormValues({ ...shippingFormValues, pickupLocation: null });
    } else {
      setShippingFormValues({ ...shippingFormValues, pickupLocation: location });
    }
  }

  const setDeliveryLocationFee = (location) => {
    if (location === 'none') {
      setDeliveryFee(0)
    }
    let locations = deliverySettings.locations.rows;
    for (let i = 0; i < locations.length; i++) {
      if (locations[i].slug === location) {
        for (let j = 0; j < locations.length; j++) {
          if (locations[i]?.amounts[j]?.currency_id === currentCurrency) {
            setDeliveryFee(locations[i].amounts[j].amount);
          }
        }
      }
    }
  }

  const [customerName, setCustomerName] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [orderNotes, setOrderNotes] = useState("");

  const onlyDigitalProducts = () => {
    if (!cart.length > 0) return false;

    const hasPhysical = cart.find(function (elem, index) {
      return elem.type === "physical";
    });

    const hasService = cart.find(function (elem, index) {
      return elem.type === "service";
    })

    if (hasPhysical || hasService) {
      return false
    }
    else return true;
  }

  const [shippingFormValues, setShippingFormValues] = useState({
    customerName: "",
    customerEmail: "",
    customerAddress: "",
    dialCode: "+234",
    phone: "",
    deliveryMethod: "",
    deliveryLocation: "",
    pickupLocation: "",
    couponCode: "",
    orderNotes: "",
  });

  const [shippingFormValidation, setShippingFormValidation] = useState({

  });

  const validateShippingForm = () => {
    if (shippingFormValues.customerName === "" || typeof shippingFormValues.customerName !== "string") {
      setShippingFormValidation({ customerName: "Please enter your name" });
      return { error: true, message: "Please enter your name" }
    }

    if (shippingFormValues.dialCode === "" || typeof shippingFormValues.dialCode !== "string") {
      setShippingFormValidation({ dialCode: "Please select a dialCode" });
      setShippingFormValidation({ ...shippingFormValidation, dialCode: "Please select a dialCode" });
      return { error: true, message: "Please select a dialCode" }
    }

    if (shippingFormValues.phone === "" || typeof shippingFormValues.phone !== "string") {
      setShippingFormValidation({ phone: "Please enter your phone number" });
      setShippingFormValidation({ ...shippingFormValidation, phone: "Please enter your phone number" });
      return { error: true, message: "Please enter your phone number" }
    }

    if (shippingFormValues.customerEmail === "" || typeof shippingFormValues.customerEmail !== "string") {
      setShippingFormValidation({ email: "Please enter your email" });
      setShippingFormValidation({ ...shippingFormValidation, customerEmail: "Please enter your email" });
      return { error: true, message: "Please enter your email" }
    }

    if (shippingFormValues.deliveryMethod === "delivery" && (typeof shippingFormValues.customerAddress !== "string" || !shippingFormValues.customerAddress)) {
      setShippingFormValidation({ address: "Please enter your address" });
      setShippingFormValidation({ ...shippingFormValidation, customerAddress: "Please enter your address" });
      return { error: true, message: "Please enter your address" }
    }

    return { success: true };

  }

  const [paymentError, setPaymentError] = useState("");

  const [allStoreCategories, setAllStoreCategories] = useState(null);

  const [currentCategory, setCurrentCategory] = useState("all");

  const getStoreTax = () => {
    let hasTax = deliverySettings?.settings?.tax;
    if (hasTax) {
      return deliverySettings?.settings?.tax;
    } else {
      return false;
    }
  }

  const [coupon, setCoupon] = useState(null);

  const [discountAmt, setDiscountAmt] = useState(0);

  const [filterParams, setFilterParams] = useState({
    category: null,
    priceOrder: null,
    maxPriceRange: null,
    searchQuery: null,
  });

  const [openCart, setOpenCart] = useState(false);
  const toggleOpenCart = () => {
    setOpenCart(!openCart);
  }

  const [cart, setCart] = useState([]);
  const [cartLoaded, setCartLoaded] = useState(false);

  // Load cart from localStorage after hydration
  useEffect(() => {
    try {
      const saved = localStorage.getItem('storefrontCart');
      if (saved) {
        setCart(JSON.parse(saved));
      }
    } catch {
      // malformed or unavailable
    }
    setCartLoaded(true);
  }, []);

  // Sync cart to localStorage on every change (skip the initial empty state)
  useEffect(() => {
    if (!cartLoaded) return;
    try {
      localStorage.setItem('storefrontCart', JSON.stringify(cart));
    } catch {
      // localStorage full or unavailable
    }
  }, [cart, cartLoaded]);

  const checkForProduct = (product) => {
    if (cart.length) {
      return cart.find((p) => p.id === product.id);
    }
  }

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      const obj1 = arr1[i];
      const obj2 = arr2[i];
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }
    }

    return true;
  };

  const addToCart = (product) => {
    if (product.variants.length > 0) {
      const productIndex = cart.findIndex((item) => item.id === product.id && (areArraysEqual(item?.matchingVariant, product?.matchingVariant) || !item?.matchingVariant));

      if (productIndex !== -1) {
        // If the product with the same id and matchingVariant or just the same id exists in the cart, increase its qty by 1
        setCart((prevCart) => {
          const updatedCart = [...prevCart];
          updatedCart[productIndex].qty += 1;
          return updatedCart;
        });
      } else {
        // If the product with different matchingVariant is not already in the cart, add it to the cart with qty 1
        setCart((prevCart) => [
          ...prevCart,
          {
            ...product,
            qty: 1,
          }
        ]);
      }
    } else {
      const productIndex = cart.findIndex((item) => item.id === product.id )
      if (productIndex !== -1) {
        setCart((prevCart) => {
          const updatedCart = [...prevCart];
          updatedCart[productIndex].qty += 1;
          return updatedCart;
        });
      } else { 
        setCart((prevCart) => [
          ...prevCart,
          {
            ...product,
            qty: 1,
          }
        ]);
      }
    }
  }

  const areMatchingVariants = (variant1, variant2) => {
    return JSON.stringify(variant1) === JSON.stringify(variant2);
  };

  const reduceProductQty = (product) => {
    setCart((prevCart) => {
      return prevCart.map((item) => {
        if (item.id === product.id && (!product?.matchingVariant || areMatchingVariants(item.matchingVariant, product?.matchingVariant))) {
          const newQty = item.qty - 1;
          return {
            ...item,
            qty: newQty >= 0 ? newQty : 0, // Ensure the quantity is never negative
          };
        }
        return item;
      }).filter((item) => item.qty > 0);
    });

    // const existingProduct = checkForProduct(product);
    // if (existingProduct) {
    //   if (product.qty === 1) {
    //     removeFromCart(product)
    //     return
    //   }
    //
    //   for (let i = 0; i < cart.length; i++) {
    //     if (cart[i].id === product.id) {
    //       let newCart = cart;
    //       newCart[i].qty = newCart[i].qty - 1;
    //       setCart([...newCart])
    //     }
    //   }
    // }
  }

  const removeFromCart = (product) => {
    if (product.matchingVariant) {
      const filteredList = cart.filter(cartItem => {
        const matchingVariantMatch =
          product.matchingVariant &&
          JSON.stringify(product.matchingVariant) ===
          JSON.stringify(cartItem.matchingVariant);
        return !matchingVariantMatch;
      });

      setCart(filteredList);
    } else {
      setCart(existingItems => existingItems.filter(existingItem => existingItem.id !== product.id));
    }
  }

  const [storeName, setStoreName] = useState("")
  const [storeLogo, setStoreLogo] = useState("")

  const [currentCurrency, setCurrentCurrency] = useState("NGN")
  const chooseCurrency = (currency) => {
    setCurrentCurrency(currency);
    setCart([]); // useEffect will sync the empty cart to localStorage
  }
  const getCurrentCurrencySign = () => {
    if (currentCurrency === "NGN") {
      return "₦";
    }
    if (currentCurrency === "USD") {
      return "$";
    }
  }

  const [priceFilterAmount, setPriceFilterAmount] = useState(20000)

  const [activeAttributes, setActiveAttributes] = useState([]);

  const [thisStoreProducts, setThisStoreProducts] = useState(null);

  return (
    <AppContext.Provider value={{
      customerName,
      setCustomerName,
      customerEmail,
      setCustomerEmail,
      customerAddress,
      setCustomerAddress,
      orderNotes,
      setOrderNotes,
      shippingFormValues,
      setShippingFormValues,
      validateShippingForm,
      shippingFormValidation,
      paymentError,
      setPaymentError,
      currentCategory,
      setCurrentCategory,
      getStoreTax,
      coupon,
      setCoupon,
      discountAmt,
      setDiscountAmt,
      filterParams,
      setFilterParams,

      activeAttributes, 
      setActiveAttributes,

      thisStoreProducts,
      setThisStoreProducts,

      cartModalShow,
      setCartModalShow,
      hideCartModal,
      openCartModal,
      toggleCartModal,
      cartPage,
      setCartPage,
      changeCartPage,
      productModalShow,
      setProductModalShow,

      filterModalShow,
      setFilterModalShow,
      toggleFilterModal,
      hideFilterModal,
      showFilterModal,
      priceFilterAmount,
      setPriceFilterAmount,

      deliveryFee,
      setDeliveryFee,
      deliveryMethod,
      setDeliveryMethod,
      deliverySettings,
      setDeliverySettings,
      selectDeliveryMethod,
      selectDeliveryLocation,
      pickupLocations,
      setPickupLocations,
      selectPickupLocation,

      openCart,
      setOpenCart,
      toggleOpenCart,
      onlyDigitalProducts,

      storeName,
      setStoreName,
      storeLogo,
      setStoreLogo,
      cart,
      addToCart,
      reduceProductQty,
      removeFromCart,
      currentCurrency,
      setCurrentCurrency,
      chooseCurrency,
      allStoreCategories,
      setAllStoreCategories,
      getCurrentCurrencySign,
    }}>{children}</AppContext.Provider>
  )
}

export default AppContext;